(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-sv-video]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const video = root.querySelector('video');
      const toggle = root.querySelector('[data-video-toggle]');
      if (!video || !toggle) return;
      toggle.hidden = false;
      const sync = () => { toggle.textContent = video.paused ? 'Play' : 'Pause'; toggle.setAttribute('aria-label', video.paused ? 'Play workshop video' : 'Pause workshop video'); };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      toggle.addEventListener('click', () => video.paused ? video.play().catch(sync) : video.pause());
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      if (!reduced.matches && !navigator.connection?.saveData) video.play().catch(sync);
      reduced.addEventListener('change', e => {if(e.matches) video.pause();});
      sync();
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

